import React from 'react';
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Legals.css";

const PrivacyStatement = () => {
  return (
    <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit">
      <div className="legal-container">
        <h1>Privacy Statement</h1>
        <p style={{ textAlign: "center" }} ><strong>Effective Date:</strong> March 10, 2025</p>

        <p>
          At S&S Healthcare Consulting, we are committed to protecting your privacy. This Privacy Statement outlines how we collect, use, store, and protect your personal information in compliance with HIPAA, CCPA, GDPR, and other relevant data protection laws.
        </p>

        <h2>Information We Collect</h2>

        <div className="legal-highlight">
          <p>📌 Personal Information: Name, email, phone number, address, job title, and healthcare facility details.</p>
          <p>📌 Health-Related Information: If applicable, for healthcare software integration.</p>
          <p>📌 Technical Data: IP addresses, browser type, and cookies for website analytics.</p>
        </div>

        <h2>How We Use Your Information</h2>

        <div className="legal-highlight">
          <p>✔ To provide and enhance our healthcare consulting and software solutions.</p>
          <p>✔ To communicate with clients regarding services, support, and updates.</p>
          <p>✔ To ensure compliance with HIPAA and other regulations.</p>
          <p>✔ To improve website functionality and user experience.</p>
        </div>

        <h2>Data Sharing and Security</h2>
        <p>
          We do not sell personal data. Data may be shared with third-party service providers strictly for operational needs. We implement strong encryption, access control, and HIPAA-compliant security measures to protect sensitive information.
        </p>

        <h2>Your Rights</h2>
        <p>
          You have the right to access, modify, or request deletion of your data. Contact us at contact@sshealthcareconsulting.com to exercise your rights.
        </p>

      </div>
    </motion.div>
  );
};

export default PrivacyStatement;
